<template>
  <div>
    <div v-if="visible" class="dummy"></div>
    <template v-for="(item,idx) in list">
      <div v-if="item.visible" class="required-bar-container" :key="`bar-${idx}`" :style="{top: top+'px'}">
        <div class="flex-align unselect" style="gap:10px" @click="clickItem(item)">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.37384 1.59299C8.76325 0.535408 7.23675 0.535409 6.62616 1.59299L0.2149 12.6976C-0.395696 13.7552 0.367551 15.0772 1.58874 15.0772H14.4113C15.6325 15.0772 16.3957 13.7552 15.7851 12.6976L9.37384 1.59299ZM7.93166 9.52882C8.14202 9.52882 8.34377 9.44526 8.49252 9.2965C8.64128 9.14775 8.72484 8.946 8.72484 8.73564V5.56289C8.72484 5.35252 8.64128 5.15077 8.49252 5.00202C8.34377 4.85327 8.14202 4.7697 7.93166 4.7697C7.72129 4.7697 7.51954 4.85327 7.37079 5.00202C7.22204 5.15077 7.13847 5.35252 7.13847 5.56289L7.13847 8.73564C7.13847 8.946 7.22204 9.14775 7.37079 9.2965C7.51954 9.44526 7.72129 9.52882 7.93166 9.52882ZM7.63024 12.6381C7.82335 12.7175 8.03996 12.7175 8.23307 12.6381C8.33043 12.6004 8.41938 12.5438 8.49482 12.4716C8.56488 12.3945 8.62122 12.3059 8.66139 12.2098C8.70579 12.1157 8.72752 12.0124 8.72484 11.9084C8.72545 11.804 8.70544 11.7005 8.66597 11.6039C8.62649 11.5072 8.56833 11.4193 8.49482 11.3452C8.41772 11.2752 8.32919 11.2188 8.23307 11.1787C8.1129 11.1293 7.98245 11.1102 7.85317 11.123C7.7239 11.1359 7.59976 11.1803 7.49166 11.2524C7.38357 11.3244 7.29483 11.4219 7.23325 11.5363C7.17166 11.6507 7.13912 11.7785 7.13847 11.9084C7.14139 12.1184 7.22355 12.3195 7.36849 12.4716C7.44393 12.5438 7.53288 12.6004 7.63024 12.6381Z" fill="white"/>
          </svg>
          <div class="subtitle6">{{ item.msg }}</div>
          <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.93333 5.68381C9.89367 5.58152 9.8342 5.48807 9.75833 5.40881L5.59167 1.24215C5.51397 1.16445 5.42173 1.10281 5.32021 1.06076C5.21869 1.01871 5.10988 0.99707 5 0.99707C4.77808 0.99707 4.56525 1.08523 4.40833 1.24215C4.33063 1.31985 4.269 1.41209 4.22695 1.51361C4.1849 1.61512 4.16326 1.72393 4.16326 1.83381C4.16326 2.05573 4.25141 2.26856 4.40833 2.42548L7.15833 5.16715H0.833333C0.61232 5.16715 0.400358 5.25494 0.244078 5.41122C0.0877975 5.56751 0 5.77947 0 6.00048C0 6.22149 0.0877975 6.43346 0.244078 6.58974C0.400358 6.74602 0.61232 6.83381 0.833333 6.83381H7.15833L4.40833 9.57548C4.33023 9.65295 4.26823 9.74512 4.22592 9.84667C4.18362 9.94822 4.16183 10.0571 4.16183 10.1671C4.16183 10.2772 4.18362 10.3861 4.22592 10.4876C4.26823 10.5892 4.33023 10.6813 4.40833 10.7588C4.4858 10.8369 4.57797 10.8989 4.67952 10.9412C4.78107 10.9835 4.88999 11.0053 5 11.0053C5.11001 11.0053 5.21893 10.9835 5.32048 10.9412C5.42203 10.8989 5.5142 10.8369 5.59167 10.7588L9.75833 6.59215C9.8342 6.51289 9.89367 6.41944 9.93333 6.31715C10.0167 6.11426 10.0167 5.8867 9.93333 5.68381Z" fill="white"/>
          </svg>
        </div>
        <i class="material-icons btn-close" @click="onClose(item)">close</i>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: "RequiredBar",
    data() {
      return {
        guides: [],
        list: [
          {
            visible: false,
            selected: false,
            id: 'email',
            path: 'service/account?menu=google',
            msg: '설정된 메일 계정이 없어 고객이 안내 메일을 받을 수 없습니다. 메일 계정을 설정해주세요.'
          },
          {
            visible: false,
            selected: false,
            id: 'pay',
            path: 'service/setting',
            msg: '플랫폼에 결제방식이 설정되어 있지 않습니다. 결제방식을 설정해주세요.'
          }
        ],
        item: undefined,
        top: 49
      }
    },
    created() {
      if(parent && parent.location && parent.location.pathname.indexOf('builder')>-1) {
        this.top = 0;
      }
      if(this.checkServiceVersion(2)) {
        this.getData();
      }
      this.$root.$on('updateServiceGuide', (res) => {
        this.guides.forEach(i=>{
          i.child.forEach(j => {
            if(j.id === res) {
              j.selected = true;
            }
          });
        });

        this.$axios.post('admin/service/guide', this.guides);
      });
    },
    computed: {
      visible() {
        return this.list.some(i => i.visible);
      },
    },
    methods: {
      clickItem(item) {
        item.visible = false;
        this.routerPush(`/office/admin/${item.path}`);
      },
      onClose(item) {
        item.visible = false;
      },
      async getData() {
        if(this.serviceInfo.plan) {
          //if(!this.serviceInfo.plan.trial) {
            let guides = await this.$axios.get('admin/service/guide');
            this.guides = guides.data;
            if(this.guides.length>0) {
              this.guides.reduce((a,c) => a.concat(c.child.filter(j => ['email', 'pay'].indexOf(j.id)>-1)), [])
                .forEach(i=>{
                  let item = this.list.find(j => j.id === i.id);
                  item.selected = i.selected;
                  item.visible = !i.selected;
                });
            }

            if(this.serviceInfo.package === 'call' && this.serviceInfo.packages.length === 1) {
              this.list = this.list.slice(0,1);
            }
          //}
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .required-bar-container
    background-color #FF8A00
    width calc(100vw - 230px)
    color white
    padding 10px 12px
    height 40px
    display flex
    align-items center
    justify-content space-between
    z-index 10
    position fixed
  .dummy
    width 100%
    height 40px
  .btn-close
    font-size 20px
    padding 4px
    cursor pointer
</style>
